import axios from '../utils/axios';

export const login = async (data) => {
  const response = await axios.post('/auth/login', data);
  return response.data;
};

export const register = async (data) => {
  const response = await axios.post('/student/create', data);
  return response.data;
};

export const retrieveQuestion = async (data) => {
  const response = await axios.post('/auth/reset-password', data);
  return response.data;
};

export const confirmAccount = async (data) => {
  const response = await axios.post('/auth/reset-password/confirm', data);
  return response.data;
};

export const resetPassword = async (data) => {
  const response = await axios.put('/auth/reset', data);
  return response.data;
};

export const checkRecords = async (data) => {
  const response = await axios.post(`/check-records`, data);
  return response.data;
};
